module.exports = __webpack_public_path__ + "static/media/puttuBiriyani.42b0f597.jpg";